import React from "react";

export function NoResults(props: { onResetFilters: () => void, className?: string }) {
    return (
        <div
            className={[
                "flex flex-col items-center justify-center text-center",
                "rounded-2xl border border-gray-200 dark:border-gray-700",
                "bg-white/80 dark:bg-gray-900/40",
                "p-8",
                props.className,
            ].filter(Boolean).join(' ')}
        >
            <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">No results</div>
            <div className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                Try widening your filters or clearing them entirely.
            </div>
            <button
                type="button"
                className="mt-4 inline-flex items-center justify-center rounded-full bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 dark:focus-visible:ring-indigo-400"
                onClick={props.onResetFilters}
            >
                Reset filters
            </button>
        </div>
    );
} 
